function setCookie(name,value,days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
  
  if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') 
  {
   
    Shopify.getCart = function(callback, cart) 
    {
      if(!cart)
      {
        return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
          if ((typeof callback) === 'function') 
          {
           
            if(cart.item_count == 0){
              
              eraseCookie('manyTimePerchase');
            }
            callback(cart,textStatus, xhr);
          }
          else 
          {
            Shopify.onCartUpdate(cart);
          }
        });
      }
      else
      {
        if ((typeof callback) === 'function') 
        {
          callback(cart);
        }
        else if(typeof Shopify.onCartUpdate ==='function') 
        {
          Shopify.onCartUpdate(cart);
        }
      }
    };
  }

Shopify.getCart(function (cart) {
 
  $.each(cart.items, function (key, value){
    console.log(cart.items);
    if(key == 0 && value.properties['shipping_interval_frequency'] && value.properties['shipping_interval_unit_type']){
      
      // console.log(value.properties['shipping_interval_frequency']);
      // console.log(value.properties['shipping_interval_unit_type']);
      var perchse = $('.poptext').attr('data-purchase');
      var x = getCookie(perchse);
      if (x) {
      }else{
         // console.log(x);
         $('.pop_content_inner').html($('.poptext').html());
         jQuery(".popup_subscription_info").fadeIn(500);
         jQuery("body").addClass('model_oppen');
        
      }
      
      
      
    }
  });
});



jQuery(".close, .btn_pop").click(function() {
  jQuery(".popup_subscription_info").fadeOut(500);
  jQuery("body").removeClass('model_oppen');
  var perchse = $('.poptext').attr('data-purchase');
   setCookie(perchse,true,7);
});